<template>
  <ion-content fullscreen>
    <ion-list>
      <ion-list-header>
        Klas 1
      </ion-list-header>
      <ion-reorder-group id="reorder" @ionItemReorder="doReorder($event)">
        <ProfileListItem :name="patient.name" v-for="patient in patients" :key="patient.id"
                         :id="patient.id"></ProfileListItem>

        <ion-list-header>
          Klas 2
        </ion-list-header>
      </ion-reorder-group>

    </ion-list>
  </ion-content>
</template>

<script>
  import { db, firebase, storage } from '@/firebase/firebase';
  import ProfileListItem from './ProfileListItem';

  export default {
    name: 'profileList',
    components: {
      ProfileListItem
    },
    data() {
      return {
        id: 0,
      };
    },
    computed: {
      patients() {
        return this.$store.state.userDetails.patient;
      }
    },
    methods: {
      doReorder(event) {
        // The `from` and `to` properties contain the index of the item
        // when the drag started and ended, respectively
        console.log('Dragged from index', event.detail.from, 'to', event.detail.to);

        // Finish the reorder and position the item in the DOM based on
        // where the gesture ended. This method can also be called directly
        // by the reorder group
        event.detail.complete();
      },
      getPatientData(patientID) {
        console.log(patientID);
      },
      addEva() {
        db.collection('users')
          .doc(firebase.auth().currentUser.uid)
          .set({
            patient: [{
              name: 'Eva',
              id: '2IjSB7u8fIWcTUjVhfr0D3mhUGx1',
            }, {
              name: 'Dummy',
              id: ''
            }]
          })
          .then(function (docRef) {
            let docId = docRef.id;
            let image = vueElement.image;
            console.log(image);
            let storageRef = storage.child('users/' + firebase.auth().currentUser.uid + '/items/' + docRef.id);
            storageRef.putString(image, 'data_url')
              .then(function (snapshot) {
                console.log('Uploaded a base64 string!');
                snapshot.ref.getDownloadURL()
                  .then(function (downloadURL) {
                    console.log('File available at', downloadURL);
                    firebase
                      .firestore()
                      .collection('users')
                      .doc(firebase.auth().currentUser.uid)
                      .collection('items')
                      .doc(docId)
                      .update({
                        image: downloadURL
                      });
                    vueElement.$router.push('/edit/');
                  });
              });

            console.log('Document written with ID: ', docRef.id);
          })
          .catch(function (error) {
            console.error('Error adding document: ', error);
          });
      },
      addKars() {
        db.collection('users')
          .doc(firebase.auth().currentUser.uid)
          .set({
            caregivers: [{
              name: 'Kars',
              id: 'GB0dnxUGMENKZVc9oLOelBqnHTG3',
            }, {
              name: 'Dummy',
              id: ''
            }]
          })
          .then(function (docRef) {
            let docId = docRef.id;
            let image = vueElement.image;
            console.log(image);
            let storageRef = storage.child('users/' + firebase.auth().currentUser.uid + '/items/' + docRef.id);
            storageRef.putString(image, 'data_url')
              .then(function (snapshot) {
                console.log('Uploaded a base64 string!');
                snapshot.ref.getDownloadURL()
                  .then(function (downloadURL) {
                    console.log('File available at', downloadURL);
                    firebase
                      .firestore()
                      .collection('users')
                      .doc(firebase.auth().currentUser.uid)
                      .collection('items')
                      .doc(docId)
                      .update({
                        image: downloadURL
                      });
                    vueElement.$router.push('/edit/');
                  });
              });

            console.log('Document written with ID: ', docRef.id);
          })
          .catch(function (error) {
            console.error('Error adding document: ', error);
          });
      },
    },
    created() {
      // this.addEva();
      // this.addKars();
    },
  };
</script>
